import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { flagSchemaMap } from "@webapp/shared";

const STORAGE_KEY = "ff-overrides";
const QUERY_KEY = [STORAGE_KEY] as const;

const useFlagOverrides = () => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => {
      const storedValue = sessionStorage.getItem(STORAGE_KEY);
      const parseResult = flagSchemaMap.safeParse(
        storedValue ? JSON.parse(storedValue) : null,
      );

      return parseResult.data ?? null;
    },
  });

  const mutation = useMutation({
    mutationFn: async (args: unknown) => {
      if (args) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(args));
      } else {
        sessionStorage.removeItem(STORAGE_KEY);
      }

      return Promise.resolve();
    },
    onSuccess: () => {
      void queryClient.invalidateQueries(QUERY_KEY);
    },
  });

  return { overrides: query.data, setOverrides: mutation.mutate };
};

export default useFlagOverrides;
